// Valor sessão
// export const textoInfo1 = (
//     <span>
//       O Investimento em cada sessão com o Dr. André Parreira é de R$130,00. Contudo, há alguns descontos:<br></br>
//       - Se forem realizadas pelo menos 4 sessões no mês, o valor fica R$120,00 por sessão;<br></br>
//       - Caso o pagamento seja realizado antes das sessões, o valor de cada uma fica R$ 110,00.
//     </span>
//   );

// export const textoInfo1 = 'Ofereço duas opções para tornar seu acompanhamento psicológico mais acessível e alinhado às suas necessidades: SESSÃO AVULSA – ideal para quem busca flexibilidade; PACOTE MENSAL – um formato pensado para quem deseja um acompanhamento contínuo com melhor custo-benefício. Cada pessoa tem uma jornada única, e o mais importante é encontrar o caminho que faça sentido para você. Para saber mais detalhes e entender qual opção melhor se encaixa no seu momento, é só entrar em contato através do WhatsApp!'

export const textoInfo1 = (
  <span>
    Cuidar da sua saúde mental nunca foi tão acessível! Você pode escolher a modalidade que melhor se adapta às suas necessidades:
    <br /><br />
    <strong>🔹 Sessão Avulsa:</strong> R$ 160,00 cada<br />
    <strong>🔹 Pacote com 4 Sessões:</strong> R$ 560,00  <span>(Cada sessão sai por R$ 140,00)</span><br />
    🔹 Obs.: <strong>1ª Sessão</strong> com valor reduzido | R$ 99,00.<br /><br />
    Se você estava esperando o momento certo para começar a terapia, essa é a sua oportunidade!
    {/* <em>Obs.: Em caso de agenda cheia, contamos com um sistema de Fila de Espera.</em> */}
  </span>
);

// Reembolso Convênio
// export const textoInfo2 = 'Por se tratar de um serviço de psicoterapia particular, é possível solicitar mensalmente um reembolso pelo seu convênio médico. O valor a ser reembolsado varia pelo plano e convênio da pessoa, contudo, todos são obrigados a reembolsar a psicoterapia. Para isso, temos uma equipe especializada, que explica todos os passos e disponibiliza os documentos necessários, da parte da clínica, para o processo do reembolso.'

// Formas de Pagamento
export const textoInfo2 = (
  <span>
    Oferecemos duas opções de pagamento simples e seguras:
    <br /><br />
    ✔️ <strong>Pix:</strong> Disponível tanto para Sessão Avulsa quanto para o Pacote de Sessões.
    <br />
    ✔️ <strong>Cartão de Crédito:</strong> Disponível exclusivamente para quem opta pelo Pacote de 4 Sessões.
  </span>
);


// Plano de Saúde e Convênio
export const textoInfo3 = (
  <span>
    Atendo na modalidade de reembolso. Cada plano de saúde define o percentual reembolsado, que pode variar de 30% a 100% do valor investido. O reembolso é um direito do beneficiário, conforme regulamentação da ANS.<br /><br />
    É importante destacar que cada convênio estabelece quais documentos são necessários para a solicitação. Por isso, recomendamos que você entre em contato com o suporte do seu plano para confirmar os critérios.
  </span>
);

// Terapia On-line
export const textoInfo4 = 'Para participar da Psicoterapia On-line, é necessário ter qualquer dispositivo como, celular, notebook ou tablet, com acesso à internet. As sessões são realizadas pela plataforma do Google Meet e tem a mesma dinâmica de uma sessão presencial.'

// Frequência e duração das sessões
export const textoInfo5 = 'Cada sessão tem a duração de 50 minutos, tendo inicialmente uma frequência semanal. Diante da necessidade da demanda de cada pessoa, a frequência pode ser aumentada ou reduzida.'

// Agendamento
export const textoInfo6 = 'Todo o contato comigo é realizado pelo WhatsApp. Para agendamento, basta me encaminhar 3 opções de dia/horário que melhor te atende, para que assim, seja feito o alinhamento entre sua disponibilidade e a minha agenda.'